/**
 * @generated SignedSource<<ae0dc08246be657e33694c3b65225ede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateWeightableInput = {
  clientMutationId?: string | null;
  weightableId: string;
  weight: number;
};
export type PopupGroupDetailPageContainer_updateDeliverWeightMutation$variables = {
  input: UpdateWeightableInput;
};
export type PopupGroupDetailPageContainer_updateDeliverWeightMutationVariables = PopupGroupDetailPageContainer_updateDeliverWeightMutation$variables;
export type PopupGroupDetailPageContainer_updateDeliverWeightMutation$data = {
  readonly updateWeightable: {
    readonly weightable: {
      readonly id: string;
      readonly weight: number;
    };
  } | null;
};
export type PopupGroupDetailPageContainer_updateDeliverWeightMutationResponse = PopupGroupDetailPageContainer_updateDeliverWeightMutation$data;
export type PopupGroupDetailPageContainer_updateDeliverWeightMutation = {
  variables: PopupGroupDetailPageContainer_updateDeliverWeightMutationVariables;
  response: PopupGroupDetailPageContainer_updateDeliverWeightMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupGroupDetailPageContainer_updateDeliverWeightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWeightablePayload",
        "kind": "LinkedField",
        "name": "updateWeightable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "weightable",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupGroupDetailPageContainer_updateDeliverWeightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWeightablePayload",
        "kind": "LinkedField",
        "name": "updateWeightable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "weightable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4702b99f039d3a278fd53f4b624ed0fc",
    "id": null,
    "metadata": {},
    "name": "PopupGroupDetailPageContainer_updateDeliverWeightMutation",
    "operationKind": "mutation",
    "text": "mutation PopupGroupDetailPageContainer_updateDeliverWeightMutation(\n  $input: UpdateWeightableInput!\n) {\n  updateWeightable(input: $input) {\n    weightable {\n      __typename\n      id\n      weight\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da86a7fcacd3a8c53265d52452055c1c";

export default node;
